import * as theme from "../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditIconOutlined from "@material-ui/icons/CreateOutlined";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import PerfectScrollbar from "react-perfect-scrollbar";
import Select from "react-select";
import { toast } from "react-toastify";
import { tr } from "date-fns/locale";
import broker from "../store/broker";
import { CheckBox } from "@material-ui/icons";
import { autofill } from "redux-form";
import { keyframes } from "styled-components";
import {
  getAllPaymentProvider,
  getPaymentProviders,
  loadBrokerages,
  getBrokeragesList,
  getSelectedBrokerage,
  brockerageIpfsDetailsModalOpened,
  brockerageIpfsDetailsModalClosed,
  getBrokerageIpfsDetailsModalOpen,
  updatePaymentProvider,
  getUpdateProvider,
  addNewIpfsDetails,
  getAllIpfsDetails,
  getIpfsAllDetailProvider,
  paymentProviderNull,
  getIpfsFailed,
  isIpfsFailed,
  isAddedBrokerageProvider,
  getSuccessMessage,
} from "../store/brokerageIpfsDetails";
import AddCircleOutlinedIcon from "@material-ui/icons/AddCircleOutlined";
import { getAllInsurerList, getInsurerListData } from "../store/insurercode";
import { getAllMgaList, getMgaListData } from "../store/mgacode";

const BrokerageIpfsDetails = () => {
  return <IpfsDetailsPane></IpfsDetailsPane>;
};

const IpfsDetailsPane = () => {
  const dispatch = useDispatch();

  const onBrokerageIpsDetailsModelChangeHandle = () => {
    dispatch(brockerageIpfsDetailsModalOpened());
  };

  const onUpdatePaymentProviderModelChangeHandle = async (provider) => {
    await dispatch(updatePaymentProvider(provider));
    await dispatch(brockerageIpfsDetailsModalOpened());
  };

  useEffect(() => {
    dispatch(getAllIpfsDetails());
  }, [dispatch]);

  useEffect(async () => {
    await dispatch(getAllInsurerList("carrierCode"));
    await dispatch(getAllMgaList("mgaCode"));
  }, [dispatch]);
  const ipfsAllDetailProvider = useSelector(getIpfsAllDetailProvider);

  return (
    <div className="m-4">
      <div className="d-flex">
        <div
          className="m-2"
          style={{
            width: "100%",
          }}
        >
          <div
            className="d-flex"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.2vw",
            }}
          >
            Brokerage IPFS Details
          </div>

          <div
            className="d-flex m-2"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              paddingTop: "25px",
              fontSize: "0.8vw",
            }}
          >
            <table className="table  table-sm">
              <thead>
                <tr>
                  <th scope="col">Provider Name</th>
                  <th scope="col ">Brokerage</th>
                  <th scope="col ">Entity Code</th>
                  <th scope="col ">Contact Name</th>
                  <th scope="col ">Actions</th>
                </tr>
              </thead>
              <tbody>
                {ipfsAllDetailProvider &&
                  ipfsAllDetailProvider?.map((provider, index) => {
                    const providerName =
                      provider?.brokeragePaymentProvider?.[0]?.provider;
                    const brokerageName = provider?.brokerageDetails?.[0]?.name;
                    return (
                      <tr scope="row" className="thead-light">
                        <th scope="row">{providerName}</th>
                        <th scope="row">{brokerageName}</th>
                        <th scope="row">{provider.entityCode}</th>
                        <th scope="row">{provider.contactName}</th>
                        <th scope="row">
                          <div
                            className="text-center"
                            style={{
                              backgroundColor: theme.COLORS.secondary_orange,
                              width: "30px",
                              height: "30px",
                              padding: 4,
                              borderRadius: 16,
                              color: "white",
                              cursor: "pointer",
                            }}
                          >
                            <EditIconOutlined
                              text="Update"
                              fontSize="small"
                              onClick={() =>
                                onUpdatePaymentProviderModelChangeHandle(
                                  provider
                                )
                              }
                            />
                          </div>
                        </th>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_orange,
                border: 5,
                marginLeft: "10px",
              }}
              onClick={onBrokerageIpsDetailsModelChangeHandle}
            >
              Add Brokerages Ipfs Details
            </Button>
          </div>
        </div>
      </div>
      <IpfsDetailsModal></IpfsDetailsModal>
    </div>
  );
};

const IpfsDetailsModal = (props) => {
  const newBrokerageIpfsDetailsState = useSelector(
    getBrokerageIpfsDetailsModalOpen
  );
  return (
    <Modal
      size="md"
      isOpen={newBrokerageIpfsDetailsState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "40rem",
          width: "50rem",
          position: "absolute",
          top: "8vh",
          left: "20vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <IpfsPage></IpfsPage>
    </Modal>
  );
};

const IpfsPage = (props) => {
  const dispatch = useDispatch();
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedCarriers, setSelectedCarriers] = useState([]);
  const [selectedMga, setSelectedMga] = useState([]);

  const [selectedBrokerage, setSelectedBrokerage] = useState(null);
  const [entityCode, setEntityCode] = useState("");
  const [contactName, setContactName] = useState("");
  const [commercialRateChart, setCommercialRateChart] = useState("");
  const [personalRateChart, setPersonalRateChart] = useState("");
  const [commercialQuotingConfigurations, setCommercialQuotingConfigurations] =
    useState("");
  const [personalQuotingConfigurations, setPersonalQuotingConfigurations] =
    useState("");
  const [commercialFeePlan, setCommercialFeePlan] = useState("");
  const [personalFeePlan, setPersonalFeePlan] = useState("");
  const [mgaList, setMgaList] = useState([{ name: "", code: "" }]);
  const [carriersList, setCarriersList] = useState([{ name: "", code: "" }]);

  const [entityCodeError, setEntityCodeError] = useState("");
  const [contactNameError, setContactNameError] = useState("");
  const [selectMgaError, setSelectMgaError] = useState("");

  const [providerNameError, setProviderNameError] = useState("");
  const [brokerageError, setBrokerageError] = useState("");
  const [commercialRateChartError, setCommercialRateChartError] = useState("");
  const [personalRateChartError, setPersonalRateChartError] = useState("");
  const [
    commercialQuotingConfigurationsError,
    setCommercialQuotingConfigurationsError,
  ] = useState("");
  const [
    personalQuotingConfigurationsError,
    setPersonalQuotingConfigurationsError,
  ] = useState("");
  const [commercialFeePlanError, setCommercialFeePlanError] = useState("");
  const [personalFeePlanError, setPersonalFeePlanError] = useState("");
  useEffect(() => {
    dispatch(getAllPaymentProvider());
  }, [dispatch]);

  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);

  const paymentProviders = useSelector(getPaymentProviders);
  const brokerages = useSelector(getBrokeragesList);
  const getUpdateProviders = useSelector(getUpdateProvider);
  const selectedProviderList = getUpdateProviders.brokeragePaymentProvider?.[0];
  const selectedBrokeragesList = getUpdateProviders.brokerageDetails?.[0];
  const carrierList = useSelector(getInsurerListData);
  const mgaCodeList = useSelector(getMgaListData);
  const isAddProvider = useSelector(isAddedBrokerageProvider);
  const successMessage = useSelector(getSuccessMessage);
  const failedMessage = useSelector(getIpfsFailed);
  const isFailed = useSelector(isIpfsFailed);

  useEffect(() => {
    if (isFailed && failedMessage)
      toast.error(failedMessage.error, {
        style: {
          backgroundColor: theme.COLORS.toast_red,
          color: theme.COLORS.white_Indo,
        },
      });
  }, [isFailed]);

  useEffect(() => {
    if (isAddProvider) {
      toast.success(successMessage.message);
    }
  });

  const isDefaultItems = carrierList?.filter(
    (item) => item?.isDefault === true
  );
  const isMgaDefaultItems = mgaCodeList?.filter(
    (item) => item?.isDefault === true
  );
  useEffect(() => {
    setSelectedProvider({
      value: selectedProviderList?._id,
      label: selectedProviderList?.provider,
    });
    setSelectedBrokerage({
      value: selectedBrokeragesList?.code,
      label: selectedBrokeragesList?.name,
    });
    setEntityCode(getUpdateProviders.entityCode);
    setContactName(getUpdateProviders.contactName);
    if (Array.isArray(getUpdateProviders.commercialRateChart)) {
      setCommercialRateChart(getUpdateProviders.commercialRateChart.join(","));
    } else {
      setCommercialRateChart(getUpdateProviders.commercialRateChart);
    }
    if (Array.isArray(getUpdateProviders.personalRateChart)) {
      setPersonalRateChart(getUpdateProviders.personalRateChart.join(","));
    } else {
      setPersonalRateChart(getUpdateProviders.personalRateChart);
    }
    if (Array.isArray(getUpdateProviders.commercialQuotingConfigurations)) {
      setCommercialQuotingConfigurations(
        getUpdateProviders.commercialQuotingConfigurations.join(",")
      );
    } else {
      setCommercialQuotingConfigurations(
        getUpdateProviders.commercialQuotingConfigurations
      );
    }
    if (Array.isArray(getUpdateProviders.personalQuotingConfigurations)) {
      setPersonalQuotingConfigurations(
        getUpdateProviders.personalQuotingConfigurations.join(",")
      );
    } else {
      setPersonalQuotingConfigurations(
        getUpdateProviders.personalQuotingConfigurations
      );
    }
    setCommercialFeePlan(getUpdateProviders.commercialFeePlan);
    setPersonalFeePlan(getUpdateProviders.personalFeePlan);

    if (Array.isArray(getUpdateProviders.gaCode)) {
      setMgaList(getUpdateProviders.gaCode);
    } else {
      setMgaList([{ name: "", code: getUpdateProviders.gaCode }]);
    }
    if (Array.isArray(getUpdateProviders.carrierCode)) {
      setCarriersList(getUpdateProviders.carrierCode);
    } else {
      setCarriersList([{ name: "", code: getUpdateProviders.carrierCode }]);
    }
    if (Array.isArray(getUpdateProviders.carrierCode)) {
      setSelectedCarriers(getUpdateProviders.carrierCode);
    }
    if (Array.isArray(getUpdateProviders.gaCode)) {
      setSelectedMga(getUpdateProviders.gaCode);
    }
  }, []);

  const providerOptions = paymentProviders.map((provider) => ({
    value: provider._id,
    label: provider.provider,
  }));

  const brokeragesOptions = brokerages.map((broker) => ({
    value: broker.code,
    label: broker.name,
  }));

  const customStyles = {
    control: (provided) => ({
      ...provided,
      color: theme.COLORS.dark_navy_blue,
      border: `2px solid ${theme.COLORS.secondary_skyblue}`,
      borderRadius: 5,
      letterSpacing: 1.2,
      backgroundColor: theme.COLORS.tertiary_ligthindigo,
    }),
    option: (provided) => ({
      ...provided,
      color: "rgb(63, 68, 90)",
    }),
  };
  const boxStyle = {
    border: "2px solid #ccc",
    padding: "10px",
    marginBottom: "20px",
    borderRadius: "5px",
  };

  const inputStyle = {
    marginBottom: "10px",
  };

  const onAddButtonClick = (e) => {
    e.preventDefault();
    let isValid = true;

    if (!selectedProvider || !selectedProvider.value) {
      setProviderNameError("Please select a provider.");
      isValid = false;
    } else {
      setProviderNameError("");
    }

    if (!selectedBrokerage || !selectedBrokerage.value) {
      setBrokerageError("Please select a brokerage.");
      return;
    } else {
      setBrokerageError("");
    }

    if (entityCode.trim() === "") {
      setEntityCodeError("Entity Code is required");
      isValid = false;
    } else {
      setEntityCodeError("");
    }

    if (contactName.trim() === "") {
      setContactNameError("Contact Name is required");
      isValid = false;
    } else {
      setContactNameError("");
    }

    const newData = {
      providerid: selectedProvider.value,
      brokeragesCode: selectedBrokerage.value,
      entityCode: entityCode,
      contactName: contactName,
      commercialRateChart: commercialRateChart
        .split(",")
        .map((commercialRateChart) => commercialRateChart.trim()),
      personalRateChart: personalRateChart
        .split(",")
        .map((personalRateChart) => personalRateChart.trim()),

      commercialQuotingConfigurations: commercialQuotingConfigurations
        .split(",")
        .map((commercialQuotingConfigurations) =>
          commercialQuotingConfigurations.trim()
        ),
      personalQuotingConfigurations: personalQuotingConfigurations
        .split(",")
        .map((personalQuotingConfigurations) =>
          personalQuotingConfigurations.trim()
        ),
      commercialFeePlan: commercialFeePlan,
      personalFeePlan: personalFeePlan,
      gaCode: selectedMga,
      carrierCode: selectedCarriers,
    };

    const updatePaymentProvider = {
      _id: getUpdateProviders._id,
      providerid: selectedProvider.value,
      brokeragesCode: selectedBrokerage.value,
      entityCode: entityCode,
      contactName: contactName,
      commercialRateChart: commercialRateChart,
      personalRateChart: personalRateChart,
      commercialQuotingConfigurations: commercialQuotingConfigurations
        .split(",")
        .map((commercialQuotingConfigurations) =>
          commercialQuotingConfigurations.trim()
        ),
      personalQuotingConfigurations: personalQuotingConfigurations
        .split(",")
        .map((personalQuotingConfigurations) =>
          personalQuotingConfigurations.trim()
        ),
      commercialFeePlan: commercialFeePlan,
      personalFeePlan: personalFeePlan,
      gaCode: selectedMga,
      carrierCode: selectedCarriers,
    };

    if (isValid) {
      dispatch(
        addNewIpfsDetails(
          getUpdateProviders._id ? updatePaymentProvider : newData
        )
      ).then(() => {
        if (isFailed) {
          dispatch(brockerageIpfsDetailsModalClosed());
          dispatch(paymentProviderNull());
          dispatch(getAllIpfsDetails());
        }
      });
    }
  };
  const handleSelectChange = (selectedOptions) => {
    const selectedPayload = selectedOptions.map((option) => ({
      name: option.label,
      code: option.value,
    }));

    setSelectedCarriers(selectedPayload);
  };

  const handleMGASelectChange = (selectedOptions) => {
    const selectedPayload = selectedOptions.map((option) => ({
      name: option.label,
      code: option.value,
    }));
    setSelectedMga(selectedPayload);
  };

  const selectMgaAllOptions = (e) => {
    e.preventDefault();
    dispatch(getAllMgaList("mgaCode"));
    const selectedPayload = mgaCodeList?.map((mga) => ({
      name: mga?.name,
      code: mga?.code,
    }));
    setSelectedMga(selectedPayload);
  };
  const selectMgaDefaultOptions = (e) => {
    e.preventDefault();
    dispatch(getAllMgaList("mgaCode"));
    const selectedPayload = isMgaDefaultItems?.map((mga) => ({
      name: mga?.name,
      code: mga?.code,
    }));
    setSelectedMga(selectedPayload);
  };

  const selectAllOptions = (e) => {
    e.preventDefault();
    dispatch(getAllInsurerList("carrierCode"));
    const selectedPayload = carrierList?.map((carrier) => ({
      name: carrier?.name,
      code: carrier?.code,
    }));
    setSelectedCarriers(selectedPayload);
  };

  const selectDefaultOptions = (e) => {
    e.preventDefault();
    dispatch(getAllInsurerList("carrierCode"));
    const selectedPayload = isDefaultItems?.map((carrier) => ({
      name: carrier?.name,
      code: carrier?.code,
    }));
    setSelectedCarriers(selectedPayload);
  };

  return (
    <PerfectScrollbar>
      <div className="container-fluid">
        <div className="row ml-1 p-3">
          <div
            className="text-center"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "24px",
            }}
          >
            {!getUpdateProviders._id
              ? "Add Brokerage Payment Provider"
              : "Update Brokerage Payment Provider"}
          </div>
          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="large"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(brockerageIpfsDetailsModalClosed());
                dispatch(paymentProviderNull());
              }}
            ></CancelIcon>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-10">
            <form noValidate>
              <div className="form-group row ">
                <label
                  className="col-sm-4 col-form-label "
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: theme.COLORS.grey_font_header,
                  }}
                >
                  Provider Name
                </label>
                <div className="col-sm-8">
                  <Select
                    className={`form-select ${
                      providerNameError ? "is-invalid" : ""
                    }`}
                    placeholder="Select an option"
                    styles={customStyles}
                    onChange={(selectedOption) => {
                      setSelectedProvider(selectedOption);
                    }}
                    value={selectedProvider}
                    options={providerOptions}
                    style={{
                      width: "100%",
                      height: "6vh",
                      fontSize: "1.9vmin",
                      border: "5px solid white",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }}
                  />
                  {providerNameError && (
                    <div className="invalid-feedback">{providerNameError}</div>
                  )}
                </div>
              </div>
              <div className="form-group row ">
                <label
                  className="col-sm-4 col-form-label "
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: theme.COLORS.grey_font_header,
                  }}
                >
                  Brokerage
                </label>
                <div className="col-sm-8">
                  <Select
                    className={`form-select ${
                      brokerageError ? "is-invalid" : ""
                    }`}
                    placeholder="Select an option"
                    styles={customStyles}
                    onChange={(selectedOption) => {
                      setSelectedBrokerage(selectedOption);
                    }}
                    value={selectedBrokerage}
                    options={brokeragesOptions}
                    style={{
                      width: "100%",
                      height: "6vh",
                      fontSize: "1.9vmin",
                      border: "5px solid white",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }}
                  />
                  {brokerageError && (
                    <div className="invalid-feedback">{brokerageError}</div>
                  )}
                </div>
              </div>
              <CommonInputField
                type={"text"}
                name={"entityCode"}
                label={"Entity Code"}
                placeholder={"Entity Code"}
                onChange={(event) => {
                  setEntityCode(event.target.value);
                }}
                value={entityCode || ""}
                error={entityCodeError} // Pass the error state here
              ></CommonInputField>
              <CommonInputField
                type={"text"}
                name={"contactName"}
                label={"Contact Name"}
                placeholder={"Contact Name"}
                onChange={(event) => {
                  setContactName(event.target.value);
                }}
                value={contactName || ""}
                error={contactNameError} // Pass the error state here
              ></CommonInputField>
              <CommonTextField
                type={"text"}
                name={"commercialRateChart"}
                label={"Commercial Rate Chart"}
                row="3"
                placeholder={"Commercial Rate Chart"}
                onChange={(event) => {
                  setCommercialRateChart(event.target.value);
                }}
                value={commercialRateChart || ""}
              ></CommonTextField>
              <CommonTextField
                type={"text"}
                name={"personalRateChart"}
                label={"Personal Rate Chart"}
                placeholder={"Personal Rate Chart"}
                row="3"
                onChange={(event) => {
                  setPersonalRateChart(event.target.value);
                }}
                value={personalRateChart || ""}
              ></CommonTextField>
              <CommonTextField
                type={"text"}
                name={"commercialQuotingConfigurations"}
                label={"Commercial Quoting Configurations"}
                row="3"
                placeholder={"Commercial Quoting Configurations"}
                onChange={(event) => {
                  setCommercialQuotingConfigurations(event.target.value);
                }}
                value={commercialQuotingConfigurations || ""}
              ></CommonTextField>
              <CommonTextField
                type={"text"}
                name={"personalQuotingConfigurations"}
                label={"Personal Quoting Configurations"}
                row="3"
                placeholder={"Personal Quoting Configurations"}
                onChange={(event) => {
                  setPersonalQuotingConfigurations(event.target.value);
                }}
                value={personalQuotingConfigurations || ""}
              ></CommonTextField>
              <CommonInputField
                type={"text"}
                name={"commercialFeePlan"}
                label={"Commercial Fee Plan (%)"}
                placeholder={"Commercial Fee Plan"}
                onChange={(event) => {
                  const regExp = /^\d*\.?\d*$/;
                  const inputValue = event.target.value;
                  if (inputValue === "" || regExp.test(inputValue)) {
                    setCommercialFeePlan(inputValue);
                  }
                }}
                value={commercialFeePlan || ""}
                error={commercialFeePlanError}
              ></CommonInputField>
              <CommonInputField
                type={"text"}
                name={"personalFeePlan"}
                label={"Personal Fee Plan (%)"}
                placeholder={"Personal Fee Plan"}
                onChange={(event) => {
                  const regExp = /^\d*\.?\d*$/;
                  const inputValue = event.target.value;
                  if (inputValue === "" || regExp.test(inputValue)) {
                    setPersonalFeePlan(inputValue);
                  }
                }}
                value={personalFeePlan || ""}
                error={personalFeePlanError}
              ></CommonInputField>

              <div style={boxStyle} className="mt-4">
                <span
                  className="col-sm-4 col-form-label"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: theme.COLORS.grey_font_header,
                  }}
                >
                  Select MGA Code
                </span>
                <div className="col-sm-12 py-4">
                  <Select
                    className="form-select"
                    placeholder="Select MGA Code options"
                    isMulti
                    onChange={handleMGASelectChange}
                    value={selectedMga.map((option) => ({
                      label: option.name,
                      value: option.code,
                    }))}
                    options={mgaCodeList.map((option) => ({
                      label: option.name,
                      value: option.code,
                    }))}
                    required
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        width: "100%",
                        fontSize: "1.9vmin",
                        border: "5px solid white",
                        borderRadius: 15,
                        fontFamily: "GibsonRegular",
                      }),
                    }}
                  />
                  <div className="py-3">
                    <Button
                      style={{
                        color: "white",
                        height: "4vh",
                        fontFamily: "GibsonSemiBd",
                        fontSize: 12,
                        backgroundColor: theme.COLORS.secondary_skyblue,
                        border: 0,
                        width: "10vw",
                        marginInline: "5px",
                      }}
                      onClick={selectMgaAllOptions}
                    >
                      Select All
                    </Button>
                    <Button
                      style={{
                        color: "white",
                        height: "4vh",
                        fontFamily: "GibsonSemiBd",
                        fontSize: 12,
                        backgroundColor: theme.COLORS.secondary_skyblue,
                        border: 0,
                        width: "10vw",
                      }}
                      onClick={selectMgaDefaultOptions}
                    >
                      Select Default
                    </Button>
                  </div>
                </div>
              </div>
              <div style={boxStyle} className="mt-4">
                <span
                  className="col-sm-4 col-form-label"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: theme.COLORS.grey_font_header,
                  }}
                >
                  Select Carrier Code
                </span>
                <div className="col-sm-12 py-4">
                  <Select
                    className="form-select"
                    placeholder="Select Carrier Code options"
                    isMulti
                    onChange={handleSelectChange}
                    value={selectedCarriers.map((option) => ({
                      label: option.name,
                      value: option.code,
                    }))}
                    options={carrierList.map((option) => ({
                      label: option.name,
                      value: option.code,
                    }))}
                    required
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        width: "100%",
                        fontSize: "1.9vmin",
                        border: "5px solid white",
                        borderRadius: 15,
                        fontFamily: "GibsonRegular",
                      }),
                    }}
                  />
                  <div className="py-3">
                    <Button
                      style={{
                        color: "white",
                        height: "4vh",
                        fontFamily: "GibsonSemiBd",
                        fontSize: 12,
                        backgroundColor: theme.COLORS.secondary_skyblue,
                        border: 0,
                        width: "10vw",
                        marginInline: "5px",
                      }}
                      onClick={selectAllOptions}
                    >
                      Select All
                    </Button>
                    <Button
                      style={{
                        color: "white",
                        height: "4vh",
                        fontFamily: "GibsonSemiBd",
                        fontSize: 12,
                        backgroundColor: theme.COLORS.secondary_skyblue,
                        border: 0,
                        width: "10vw",
                      }}
                      onClick={selectDefaultOptions}
                    >
                      Select Default
                    </Button>
                  </div>
                </div>
              </div>

              <div
                className="form-group row justify-content-center"
                style={{ paddingTop: "2%" }}
              >
                <div className="col-3">
                  <button
                    type="submit"
                    style={{
                      backgroundColor: theme.COLORS.secondary_orange,
                      borderRadius: "10px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={onAddButtonClick}
                  >
                    {!getUpdateProviders._id ? "Add" : "Update"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};

const CommonInputField = ({
  label = "Sample common label",
  onChange,
  value,
  defaultValue,
  placeholder,
  error, // Add error prop
  type,
  name,
}) => {
  return (
    <div className="form-group row">
      <label
        className="col-sm-4 col-form-label"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          color: theme.COLORS.grey_font_header,
        }}
      >
        {label}
      </label>
      <div className="col-sm-8">
        <input
          autoFocus
          type={type}
          name={name}
          className={`form-control ${error ? "is-invalid" : ""}`}
          placeholder={placeholder}
          required
          style={{
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${
              error ? "red" : theme.COLORS.secondary_skyblue
            }`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          onChange={onChange}
        />
        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    </div>
  );
};

const CommonTextField = ({
  label = "Sample common label",
  onChange,
  value,
  defaultValue,
  placeholder,
  error, // Add error prop
  type,
  name,
  row,
}) => {
  return (
    <div className="form-group row">
      <label
        className="col-sm-4 col-form-label"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          color: theme.COLORS.grey_font_header,
        }}
      >
        {label}
      </label>
      <div className="col-sm-8">
        <textarea
          autoFocus
          type={type}
          name={name}
          rows={row}
          className={`form-control ${error ? "is-invalid" : ""}`}
          placeholder={placeholder}
          required
          style={{
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${
              error ? "red" : theme.COLORS.secondary_skyblue
            }`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          onChange={onChange}
        />
        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    </div>
  );
};

export default BrokerageIpfsDetails;
